export const PADDING = { DESKTOP: 7, TABLET: 4, MOBILE: 3 }
